import firebaseSvc from "../../services/firebase.service";
import { FaCopy, FaShare, FaTimes } from "react-icons/fa";
import { useEffect, useState } from "react";
import { SwitchTabs } from "../switch-tabs";
import { utils } from "../../utils";
import s from "./index.module.css";
import QRCode from "react-qr-code";

export function QrCodeModal({ 
    config, 
    data, 
    toggleShow = () => null
}) {
    const tabId = {
        SHOP_QR: "shop-qr",
        PAYMENT_QR: "payment-qr",
    }
    const [messages, setMessages] = useState({});
    const [selectedTab, setSelectedTab] = useState(tabId.SHOP_QR);
    const [tabs, setTabs] = useState([]);


    useEffect(() => {
      firebaseSvc.read("messages", (message) => setMessages(message));
      let tab = [{label: "Shop QR", id: tabId.SHOP_QR}];
      if(data?.upi_id) {
        tab.push({label: "Payment QR", id: tabId.PAYMENT_QR});
      }
      setTabs(tab);
    }, []);

    const getQrAreaTitle = () => {
        const type = data?.shop_type?.toLowerCase()?.trim() || 'product';
        if(selectedTab === tabId.SHOP_QR) {
          return type === 'service' ?"Scan to book" : "Scan to order";
        } else if(selectedTab === tabId.PAYMENT_QR) {
          return "Scan to pay";
        }
    }

    const getReferrerUrl = () => {
        return utils.getshopReferrerUrl(data?.primary_num || '', data?.shop_id || '');
      };
    
    const getUpiId = () => {
        return utils.getUpiUrl(data);
    }
    
    const getQRURL = (force = false) => {
        if(selectedTab === tabId.SHOP_QR) {
          return getReferrerUrl();
        } else if(selectedTab === tabId.PAYMENT_QR) {
          return !force ? data?.upi_id || '' : getUpiId();
        }
        return '';
    }

    const getReferralMessage = () => {
        let type = data?.shop_type?.toLowerCase()?.trim() || 'product';
        if(selectedTab === tabId.SHOP_QR) {
            if(config?.referral_message?.trim()){
            return config?.referral_message?.trim() || '';
            } else if(messages?.referral?.[type]){
            return messages?.referral?.[type];
            } else {
                if(type === 'service') {
                    return "👋 Hi! Check out on solo. book appointments online here";
                } else {
                    return "👋 Hi! Check out on Solo. View catalog and order online here";
                }
            }
        } else if(selectedTab === tabId.PAYMENT_QR) {
            if(config?.referral_message?.trim()){
            return config?.referral_message?.trim() || '';
            } else if(messages?.payment){
            return messages?.payment;
            } else {
            return "👋 Hi! using Solo. you can pay";
            }
        }
        return '';
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(getQRURL());
        alert("Copied to clipboard!");
    }

    const handleShare = async () => {
        let message = getReferralMessage() + '\n\n'+ getQRURL(true);
        try {
            await navigator.share({
                title: (data?.name || '') + " - SOLO",
                text: message,
            });
        } catch(error) {
            alert("Share failed!");
        }
    }

    return (
        <div className={s.qrCodeModalArea}>
            <div className={s.qrCodeModalBackdrop} onClick={() => toggleShow(false)}></div>
            <div className={s.qrCodeModal}>
                <div className={s.closeButton} onClick={() => toggleShow(false)}>
                    <FaTimes size={24} color="#6B717D99" />
                </div>
                <div className={s.shopInfoContainer}>
                    <div className={s.imageContainer}>
                    {
                        !!(data?.images?.length) ?
                        <img
                            loading="lazy"
                            decoding="async"
                            className={s.imageLogo}
                            alt={data?.name?.[0] || ''}
                            src={utils.getImageUrl(data?.images?.[0])}
                        /> : <div className={s.shopInitial}>{data?.name?.[0] || ''}</div>
                    }
                    </div>
                    <div className={s.shopInfoContentContainer}>
                        <div className={s.shopName}>{data?.name || ''}</div>
                        <div className={s.shopCategory}>{data?.category || ""}</div>
                    </div>
                </div>
                <SwitchTabs
                    tabs={tabs || []}
                    selected={selectedTab || ''}
                    onTabChange={setSelectedTab}
                />
                <div className={s.qrContainer}>
                    <div className={s.qrCodeContainer}>
                        <div className={s.qrText}>{getQrAreaTitle()}</div>
                        {!!getReferrerUrl() && selectedTab === tabId.SHOP_QR && (
                            <QRCode value={getReferrerUrl()} style={{ width: "100%", height: "100%" }}/>
                        )}
                        {!!(data?.upi_id) && selectedTab === tabId.PAYMENT_QR && (
                            <QRCode value={getUpiId()} style={{ width: "100%", height: "100%" }}/>
                        )}
                    </div>
                </div>
                <div className={s.qrNote}>
                    <div className={s.qrNoteText}>
                        {selectedTab === tabId.SHOP_QR && "Customers can scan this QR to view products, services and place orders." } 
                        {selectedTab === tabId.PAYMENT_QR && "Customers can scan this QR to make payments directly to the shop."}
                    </div>
                </div>
                <div className={s.qrShareDetailsActionsContainer}>
                    <div className={s.qrShareURLContainer}>
                    <div className={s.qrShareURLText}>
                        {getQRURL()}
                    </div>
                    <div className={s.qrShareURLActionsContainer}>
                        <button type="button" onClick={() => handleCopy()} className={s.qrShareURLActionButton}>
                            <FaCopy size={24} color={"#0B7E36"} />
                        </button>
                        <button type="button" onClick={() => handleShare()} className={s.qrShareURLActionButton}>
                            <FaShare size={24} color={"#0B7E36"} />
                        </button>
                    </div>
                    </div>
                    <div className={s.shareMessageText}>
                        {getReferralMessage()}
                    </div>
                </div>
            </div>
        </div>
    )
}